import type { User as AuthUser } from "@/lib/authContext";

export function isAdminUser(user: AuthUser | null | undefined): boolean {
  if (!user) return false;
  const anyUser = user as any;
  const role = String(anyUser.role || anyUser.user_metadata?.role || anyUser.app_metadata?.role || "").toLowerCase();
  if (role === "admin") return true;
  if (anyUser.is_admin === true || anyUser.user_metadata?.is_admin === true) return true;
  return false;
}
